import React, { useEffect, useRef, useState } from "react";
import * as NS from "../../../styles/NotiStyled";
import * as SEC from "../../../styles/SectionStyled";
import notiIcon from "../../../assets/images/notiIcon.png";
import infoIcon from "../../../assets/images/infoIcon.png";
import darkArrow from "../../../assets/images/darkArrow.png";
import warns from "../../../assets/images/warns.png";
import { useSelector, useDispatch } from "react-redux";
import { ProfileInfo } from "../../../utils/api";
import wanrIcon from "../../../assets/images/warns.png";
import axios from "../../../utils/axios";
import { removeDuplicatesById } from "../../../utils/Helpers";
import moment from "moment";

const Notification = ({
  component,
  headTitle,
  headDesc,
  navigate,
  localState,
}) => {
  const theme = useSelector((state) => state?.isDark);
  const selectLangJson = useSelector((state) => state?.selectLangJson);
  const [notificationData, setNotificationData] = useState([]);
  const [currentPageSubs, setCurrentPageSubs] = useState(1);
  const [totalCountSubs, setTotalCountSubs] = useState(0);
  const [feildLoading, setFeildLoading] = useState(false);
  const sentinelRef = useRef();
  useEffect(() => {
    const getNotification = async () => {
      setFeildLoading(true);
      if (currentPageSubs === 1) {
        setNotificationData([]);
      }
      let url = `${ProfileInfo.getNotification}?page=${currentPageSubs}&limit=10`;
      try {
        const { data } = await axios.get(url);
        if (data?.result) {
          setNotificationData((prevList) => [
            ...prevList,
            ...data?.result?.docs,
          ]);
          setTotalCountSubs(data?.result?.totalPages);
        } else if (currentPageSubs === 1) {
          setNotificationData([]);
        }
      } catch (error) {
        console.log(error.response.data.message);
      } finally {
        setFeildLoading(false); // Ensure loading state is reset
      }
    };
    getNotification();
  }, [currentPageSubs]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          currentPageSubs < totalCountSubs &&
          !feildLoading
        ) {
          setCurrentPageSubs((prevPage) => prevPage + 1);
        }
      },
      { threshold: 0.5 } // Adjusted threshold for better triggering
    );

    if (sentinelRef.current) observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, [feildLoading, currentPageSubs, totalCountSubs]);

  const getIconType = (e) => {
    if (e === "error") {
      return wanrIcon;
    } else if (e === "info") {
      return infoIcon;
    } else {
      return "";
    }
  };
  return (
    <NS.NavBarNoti themeColor={theme}>
      <SEC.TitleRow themeColor={theme}>
        <SEC.TitleBox themeColor={theme}>
          <img
            src={darkArrow}
            onClick={() => {
              navigate(-1);
            }}
            alt=""
          />
          <SEC.HeadTitle themeColor={theme}>
            {selectLangJson.notifications}
          </SEC.HeadTitle>
        </SEC.TitleBox>
      </SEC.TitleRow>
      {notificationData?.length > 0 ? (
        <NS.NotiListContainer themeColor={theme}>
          <NS.NotiInnerList themeColor={theme}>
            <NS.NotiHeader themeColor={theme}>
              <img src={notiIcon} alt="" />
              {selectLangJson.mark_all_as_read}
            </NS.NotiHeader>
            <NS.NotiList themeColor={theme}>
              {notificationData.length > 0 ? (
                removeDuplicatesById(notificationData)?.map((val, ind) => {
                  return (
                    <NS.NotiItem key={ind} themeColor={theme}>
                      <NS.FirstNoti>
                        {val.readMark ? <NS.ColorCircle></NS.ColorCircle> : ""}
                        <NS.IconCircle>
                          <img src={getIconType(val.icon)} alt="" />
                        </NS.IconCircle>
                        <NS.NotiDesc themeColor={theme}>{val.body}</NS.NotiDesc>
                      </NS.FirstNoti>
                      <NS.FirstNoti>
                        {val.viewStatus ? <NS.NotiView>View</NS.NotiView> : ""}

                        <NS.DateTime>
                          {moment(val.createdAt).format("h:mm:ss")}&nbsp;&nbsp;
                          {moment(val.createdAt).format("DD MMM YYYY")}
                        </NS.DateTime>
                      </NS.FirstNoti>
                    </NS.NotiItem>
                  );
                })
              ) : (
                <NS.NotiItem
                  themeColor={theme}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <NS.NotiDesc themeColor={theme}>
                    {selectLangJson.no_data}
                  </NS.NotiDesc>
                </NS.NotiItem>
              )}

              {/* <NS.NotiItem themeColor={theme}>
              <NS.FirstNoti>
                <NS.ColorCircle></NS.ColorCircle>
                <NS.IconCircle>
                  <img src={warns} alt="" />
                </NS.IconCircle>
                <NS.NotiDesc themeColor={theme}>
                  You have a new request of additional license from Deepika for
                  the WorkSafe Delta.
                </NS.NotiDesc>
              </NS.FirstNoti>
              <NS.FirstNoti>
                <NS.NotiView>View</NS.NotiView>
                <NS.DateTime>10:56:42&nbsp;&nbsp;18 Jan 2023</NS.DateTime>
              </NS.FirstNoti>
            </NS.NotiItem>
            <NS.NotiItem themeColor={theme}>
              <NS.FirstNoti>
                <NS.ColorCircle></NS.ColorCircle>
                <NS.IconCircle>
                  <img src={warns} alt="" />
                </NS.IconCircle>
                <NS.NotiDesc themeColor={theme}>
                  You have a new request of additional license from Deepika for
                  the WorkSafe Delta.
                </NS.NotiDesc>
              </NS.FirstNoti>
              <NS.FirstNoti>
                <NS.DateTime>10:56:42&nbsp;&nbsp;18 Jan 2023</NS.DateTime>
              </NS.FirstNoti>
            </NS.NotiItem>
            <NS.NotiItem themeColor={theme}>
              <NS.FirstNoti>
                <NS.ColorCircle></NS.ColorCircle>
                <NS.IconCircle>
                  <img src={infoIcon} alt="" />
                </NS.IconCircle>
                <NS.NotiDesc themeColor={theme}>
                  You have a new request of additional license from Deepika for
                  the WorkSafe Delta.
                </NS.NotiDesc>
              </NS.FirstNoti>
              <NS.FirstNoti>
                <NS.NotiView>View</NS.NotiView>
                <NS.DateTime>10:56:42&nbsp;&nbsp;18 Jan 2023</NS.DateTime>
              </NS.FirstNoti>
            </NS.NotiItem>
            <NS.NotiItem themeColor={theme}>
              <NS.FirstNoti>
                <NS.ColorCircle></NS.ColorCircle>
                <NS.IconCircle>
                  <img src={warns} alt="" />
                </NS.IconCircle>
                <NS.NotiDesc themeColor={theme}>
                  You have a new request of additional license from Deepika for
                  the WorkSafe Delta.
                </NS.NotiDesc>
              </NS.FirstNoti>
              <NS.FirstNoti>
                <NS.DateTime>10:56:42&nbsp;&nbsp;18 Jan 2023</NS.DateTime>
              </NS.FirstNoti>
            </NS.NotiItem>
            <NS.NotiItem themeColor={theme}>
              <NS.FirstNoti>
                <NS.ColorCircle></NS.ColorCircle>
                <NS.IconCircle>
                  <img src={infoIcon} alt="" />
                </NS.IconCircle>
                <NS.NotiDesc themeColor={theme}>
                  You have a new request of additional license from Deepika for
                  the WorkSafe Delta.
                </NS.NotiDesc>
              </NS.FirstNoti>
              <NS.FirstNoti>
                <NS.NotiView>View</NS.NotiView>
                <NS.DateTime>10:56:42&nbsp;&nbsp;18 Jan 2023</NS.DateTime>
              </NS.FirstNoti>
            </NS.NotiItem>
            <NS.NotiItem themeColor={theme}>
              <NS.FirstNoti>
                <NS.ColorCircle></NS.ColorCircle>
                <NS.IconCircle>
                  <img src={warns} alt="" />
                </NS.IconCircle>
                <NS.NotiDesc themeColor={theme}>
                  You have a new request of additional license from Deepika for
                  the WorkSafe Delta.
                </NS.NotiDesc>
              </NS.FirstNoti>
              <NS.FirstNoti>
                <NS.DateTime>10:56:42&nbsp;&nbsp;18 Jan 2023</NS.DateTime>
              </NS.FirstNoti>
            </NS.NotiItem>
            <NS.NotiItem themeColor={theme}>
              <NS.FirstNoti>
                <NS.ColorCircle></NS.ColorCircle>
                <NS.IconCircle>
                  <img src={infoIcon} alt="" />
                </NS.IconCircle>
                <NS.NotiDesc themeColor={theme}>
                  You have a new request of additional license from Deepika for
                  the WorkSafe Delta.
                </NS.NotiDesc>
              </NS.FirstNoti>
              <NS.FirstNoti>
                <NS.NotiView>View</NS.NotiView>
                <NS.DateTime>10:56:42&nbsp;&nbsp;18 Jan 2023</NS.DateTime>
              </NS.FirstNoti>
            </NS.NotiItem> */}
              <div
                ref={sentinelRef}
                style={{ height: "1px", width: "100%" }}
              ></div>
            </NS.NotiList>
          </NS.NotiInnerList>
        </NS.NotiListContainer>
      ) : (
        <NS.NoDataCon themeColor={theme}>
          <p>No Notifications found</p>
        </NS.NoDataCon>
      )}
    </NS.NavBarNoti>
  );
};

export default Notification;
